import(/* webpackMode: "eager" */ "/app/src/components/loading-screen/loading-screen.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/loading-screen/splash-screen.tsx");
